import React, {Fragment} from 'react';
import {connect} from 'react-redux';

import mainLogo from '../../assets/intuitive.png';

import AppMobileMenu from '../AppMobileMenu';

import {
    setEnableClosedSidebar,
    setEnableMobileMenu,
    setEnableMobileMenuSmall,
} from '../../reducers/ThemeOptions';

class HeaderLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            mobile: false,
            activeSecondaryMenuMobile: false
        };

    }

    toggleEnableClosedSidebar = () => {
      console.log(this.props);
        let {enableClosedSidebar, setEnableClosedSidebar} = this.props;
        setEnableClosedSidebar(!enableClosedSidebar);
    }

    state = {
        openLeft: false,
        openRight: false,
        relativeWidth: false,
        width: 280,
        noTouchOpen: false,
        noTouchClose: false,
    };

    render() {
      

        return (
            <Fragment>
              <div className="app-header__logo">

                                <a class="logo-wrapper" href="#">  
                                            <img src={mainLogo} className="logo" alt="Intuitive Surgical" style={{marginTop: "5px",visibility:"visible"}}/>  
                                        
                                                <div className="logo-bottom-curve"></div>       
                                    </a>
                                
                                    <div className="header__pane ml-auto">
                                    
                                </div>
                    </div>
                    <div className='titleClass'>Vendor Process Insights  </div>
                <AppMobileMenu/>
            </Fragment>
        )
    }
}


const mapStateToProps = state => ({
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({

    setEnableClosedSidebar: enable => dispatch(setEnableClosedSidebar(enable)),
    setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),
    setEnableMobileMenuSmall: enable => dispatch(setEnableMobileMenuSmall(enable)),

});

// <div onClick={this.toggleEnableClosedSidebar}>
//     <Hamburger
//         active={enableClosedSidebar}
//         type="elastic"
//         onClick={() => this.setState({active: !this.state.active})}
//     />
// </div>

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);
